module.exports = {
	"contractName": "MorganStarkFactory",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "0x608060405260008054600160a060020a031916331790556103d1806100256000396000f3006080604052600436106100615763ffffffff7c01000000000000000000000000000000000000000000000000000000006000350416637726f77681146100665780638da5cb5b14610096578063d38def5b146100ab578063f2fde38b146100e6575b600080fd5b61007a600160a060020a0360043516610109565b60408051600160a060020a039092168252519081900360200190f35b3480156100a257600080fd5b5061007a610136565b3480156100b757600080fd5b506100d2600160a060020a0360043581169060243516610145565b604080519115158252519081900360200190f35b3480156100f257600080fd5b50610107600160a060020a03600435166101d9565b005b600061011361026d565b604051809103906000f08015801561012f573d6000803e3d6000fd5b5092915050565b600054600160a060020a031681565b600080839050600081600160a060020a031663c71daccb6040518163ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401602060405180830381600087803b1580156101a457600080fd5b505af11580156101b8573d6000803e3d6000fd5b505050506040513d60208110156101ce57600080fd5b505111949350505050565b600054600160a060020a031633146101f057600080fd5b600160a060020a038116151561020557600080fd5b60008054604051600160a060020a03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a36000805473ffffffffffffffffffffffffffffffffffffffff1916600160a060020a0392909216919091179055565b6040516101288061027e8339019056006080604052341561000f57600080fd5b60008054600160a060020a0319163317905560f98061002f6000396000f30060806040526004361060525763ffffffff7c0100000000000000000000000000000000000000000000000000000000600035041663b69ef8a881146057578063c71daccb14607b578063d1e4e9a314608d575b600080fd5b348015606257600080fd5b5060696095565b60408051918252519081900360200190f35b348015608657600080fd5b506069609b565b609360a0565b005b60015481565b303190565b60005473ffffffffffffffffffffffffffffffffffffffff16331460c357600080fd5b60018054340190555600a165627a7a723058201104c2feaedb262837552c299d1d1421fc03167cacc107101729dbed273ca76d0029a165627a7a723058206423049fe69ae7a891b39cac4e3e3a0b320ed85132d0a099583e0b9c2deb73a10029",
	"deployedBytecode": "0x6080604052600436106100615763ffffffff7c01000000000000000000000000000000000000000000000000000000006000350416637726f77681146100665780638da5cb5b14610096578063d38def5b146100ab578063f2fde38b146100e6575b600080fd5b61007a600160a060020a0360043516610109565b60408051600160a060020a039092168252519081900360200190f35b3480156100a257600080fd5b5061007a610136565b3480156100b757600080fd5b506100d2600160a060020a0360043581169060243516610145565b604080519115158252519081900360200190f35b3480156100f257600080fd5b50610107600160a060020a03600435166101d9565b005b600061011361026d565b604051809103906000f08015801561012f573d6000803e3d6000fd5b5092915050565b600054600160a060020a031681565b600080839050600081600160a060020a031663c71daccb6040518163ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401602060405180830381600087803b1580156101a457600080fd5b505af11580156101b8573d6000803e3d6000fd5b505050506040513d60208110156101ce57600080fd5b505111949350505050565b600054600160a060020a031633146101f057600080fd5b600160a060020a038116151561020557600080fd5b60008054604051600160a060020a03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a36000805473ffffffffffffffffffffffffffffffffffffffff1916600160a060020a0392909216919091179055565b6040516101288061027e8339019056006080604052341561000f57600080fd5b60008054600160a060020a0319163317905560f98061002f6000396000f30060806040526004361060525763ffffffff7c0100000000000000000000000000000000000000000000000000000000600035041663b69ef8a881146057578063c71daccb14607b578063d1e4e9a314608d575b600080fd5b348015606257600080fd5b5060696095565b60408051918252519081900360200190f35b348015608657600080fd5b506069609b565b609360a0565b005b60015481565b303190565b60005473ffffffffffffffffffffffffffffffffffffffff16331460c357600080fd5b60018054340190555600a165627a7a723058201104c2feaedb262837552c299d1d1421fc03167cacc107101729dbed273ca76d0029a165627a7a723058206423049fe69ae7a891b39cac4e3e3a0b320ed85132d0a099583e0b9c2deb73a10029",
	"sourceMap": "82:372:19:-;;;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;82:372:19;;;;;;",
	"deployedSourceMap": "82:372:19:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;123:122;;-1:-1:-1;;;;;123:122:19;;;;;;;;;-1:-1:-1;;;;;123:122:19;;;;;;;;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;249:203:19;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;249:203:19;-1:-1:-1;;;;;249:203:19;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;;;123:122:19;188:7;223:17;;:::i;:::-;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;-1:-1;216:24:19;123:122;-1:-1:-1;;123:122:19:o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;249:203:19:-;335:4;362:20;397:9;362:45;;446:1;420:8;-1:-1:-1;;;;;420:21:19;;:23;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;420:23:19;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;420:23:19;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;420:23:19;:27;;249:203;-1:-1:-1;;;;249:203:19:o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o;82:372:19:-;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.24;\n\nimport \"./base/Level.sol\";\nimport \"./MorganStark.sol\";\n\ncontract MorganStarkFactory is Level {\n  function createInstance(address _player) public payable returns (address) {\n    _player;\n    return new MorganStark();\n  }\n\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool)\n  {\n    _player;\n    MorganStark instance = MorganStark(_instance);\n    return instance.checkBalance() > 0;\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/MorganStarkFactory.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/MorganStarkFactory.sol",
		"exportedSymbols": {
			"MorganStarkFactory": [
				1959
			]
		},
		"id": 1960,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1916,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:19"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 1917,
				"nodeType": "ImportDirective",
				"scope": 1960,
				"sourceUnit": 2867,
				"src": "26:26:19",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/MorganStark.sol",
				"file": "./MorganStark.sol",
				"id": 1918,
				"nodeType": "ImportDirective",
				"scope": 1960,
				"sourceUnit": 1915,
				"src": "53:27:19",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 1919,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "113:5:19",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 1920,
						"nodeType": "InheritanceSpecifier",
						"src": "113:5:19"
					}
				],
				"contractDependencies": [
					1914,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1959,
				"linearizedBaseContracts": [
					1959,
					2866,
					2922
				],
				"name": "MorganStarkFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 1933,
							"nodeType": "Block",
							"src": "197:48:19",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1927,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1922,
										"src": "203:7:19",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1928,
									"nodeType": "ExpressionStatement",
									"src": "203:7:19"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 1930,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "223:15:19",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_payable$__$returns$_t_contract$_MorganStark_$1914_$",
												"typeString": "function () payable returns (contract MorganStark)"
											},
											"typeName": {
												"contractScope": null,
												"id": 1929,
												"name": "MorganStark",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1914,
												"src": "227:11:19",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_MorganStark_$1914",
													"typeString": "contract MorganStark"
												}
											}
										},
										"id": 1931,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "223:17:19",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_MorganStark_$1914",
											"typeString": "contract MorganStark"
										}
									},
									"functionReturnParameters": 1926,
									"id": 1932,
									"nodeType": "Return",
									"src": "216:24:19"
								}
							]
						},
						"documentation": null,
						"id": 1934,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1923,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1922,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1934,
									"src": "147:15:19",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1921,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "147:7:19",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "146:17:19"
						},
						"payable": true,
						"returnParameters": {
							"id": 1926,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1925,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1934,
									"src": "188:7:19",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1924,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "188:7:19",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "187:9:19"
						},
						"scope": 1959,
						"src": "123:122:19",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1957,
							"nodeType": "Block",
							"src": "343:109:19",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1943,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1938,
										"src": "349:7:19",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1944,
									"nodeType": "ExpressionStatement",
									"src": "349:7:19"
								},
								{
									"assignments": [
										1946
									],
									"declarations": [
										{
											"constant": false,
											"id": 1946,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 1958,
											"src": "362:20:19",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_MorganStark_$1914",
												"typeString": "contract MorganStark"
											},
											"typeName": {
												"contractScope": null,
												"id": 1945,
												"name": "MorganStark",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1914,
												"src": "362:11:19",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_MorganStark_$1914",
													"typeString": "contract MorganStark"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1950,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1948,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1936,
												"src": "397:9:19",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 1947,
											"name": "MorganStark",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1914,
											"src": "385:11:19",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_MorganStark_$1914_$",
												"typeString": "type(contract MorganStark)"
											}
										},
										"id": 1949,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "385:22:19",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_MorganStark_$1914",
											"typeString": "contract MorganStark"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "362:45:19"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 1955,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [],
											"expression": {
												"argumentTypes": [],
												"expression": {
													"argumentTypes": null,
													"id": 1951,
													"name": "instance",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1946,
													"src": "420:8:19",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_MorganStark_$1914",
														"typeString": "contract MorganStark"
													}
												},
												"id": 1952,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "checkBalance",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1913,
												"src": "420:21:19",
												"typeDescriptions": {
													"typeIdentifier": "t_function_external_view$__$returns$_t_uint256_$",
													"typeString": "function () view external returns (uint256)"
												}
											},
											"id": 1953,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "420:23:19",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1954,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "446:1:19",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "420:27:19",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1942,
									"id": 1956,
									"nodeType": "Return",
									"src": "413:34:19"
								}
							]
						},
						"documentation": null,
						"id": 1958,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1939,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1936,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 1958,
									"src": "275:17:19",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1935,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "275:7:19",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1938,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1958,
									"src": "294:15:19",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1937,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "294:7:19",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "274:36:19"
						},
						"payable": false,
						"returnParameters": {
							"id": 1942,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1941,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1958,
									"src": "335:4:19",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1940,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "335:4:19",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "334:6:19"
						},
						"scope": 1959,
						"src": "249:203:19",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 1960,
				"src": "82:372:19"
			}
		],
		"src": "0:455:19"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/MorganStarkFactory.sol",
		"exportedSymbols": {
			"MorganStarkFactory": [
				1959
			]
		},
		"id": 1960,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1916,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:19"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 1917,
				"nodeType": "ImportDirective",
				"scope": 1960,
				"sourceUnit": 2867,
				"src": "26:26:19",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/MorganStark.sol",
				"file": "./MorganStark.sol",
				"id": 1918,
				"nodeType": "ImportDirective",
				"scope": 1960,
				"sourceUnit": 1915,
				"src": "53:27:19",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 1919,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "113:5:19",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 1920,
						"nodeType": "InheritanceSpecifier",
						"src": "113:5:19"
					}
				],
				"contractDependencies": [
					1914,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1959,
				"linearizedBaseContracts": [
					1959,
					2866,
					2922
				],
				"name": "MorganStarkFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 1933,
							"nodeType": "Block",
							"src": "197:48:19",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1927,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1922,
										"src": "203:7:19",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1928,
									"nodeType": "ExpressionStatement",
									"src": "203:7:19"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 1930,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "223:15:19",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_payable$__$returns$_t_contract$_MorganStark_$1914_$",
												"typeString": "function () payable returns (contract MorganStark)"
											},
											"typeName": {
												"contractScope": null,
												"id": 1929,
												"name": "MorganStark",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1914,
												"src": "227:11:19",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_MorganStark_$1914",
													"typeString": "contract MorganStark"
												}
											}
										},
										"id": 1931,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "223:17:19",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_MorganStark_$1914",
											"typeString": "contract MorganStark"
										}
									},
									"functionReturnParameters": 1926,
									"id": 1932,
									"nodeType": "Return",
									"src": "216:24:19"
								}
							]
						},
						"documentation": null,
						"id": 1934,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1923,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1922,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1934,
									"src": "147:15:19",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1921,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "147:7:19",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "146:17:19"
						},
						"payable": true,
						"returnParameters": {
							"id": 1926,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1925,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1934,
									"src": "188:7:19",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1924,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "188:7:19",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "187:9:19"
						},
						"scope": 1959,
						"src": "123:122:19",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1957,
							"nodeType": "Block",
							"src": "343:109:19",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1943,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1938,
										"src": "349:7:19",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1944,
									"nodeType": "ExpressionStatement",
									"src": "349:7:19"
								},
								{
									"assignments": [
										1946
									],
									"declarations": [
										{
											"constant": false,
											"id": 1946,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 1958,
											"src": "362:20:19",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_MorganStark_$1914",
												"typeString": "contract MorganStark"
											},
											"typeName": {
												"contractScope": null,
												"id": 1945,
												"name": "MorganStark",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1914,
												"src": "362:11:19",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_MorganStark_$1914",
													"typeString": "contract MorganStark"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1950,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1948,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1936,
												"src": "397:9:19",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 1947,
											"name": "MorganStark",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1914,
											"src": "385:11:19",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_MorganStark_$1914_$",
												"typeString": "type(contract MorganStark)"
											}
										},
										"id": 1949,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "385:22:19",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_MorganStark_$1914",
											"typeString": "contract MorganStark"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "362:45:19"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 1955,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [],
											"expression": {
												"argumentTypes": [],
												"expression": {
													"argumentTypes": null,
													"id": 1951,
													"name": "instance",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1946,
													"src": "420:8:19",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_MorganStark_$1914",
														"typeString": "contract MorganStark"
													}
												},
												"id": 1952,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "checkBalance",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1913,
												"src": "420:21:19",
												"typeDescriptions": {
													"typeIdentifier": "t_function_external_view$__$returns$_t_uint256_$",
													"typeString": "function () view external returns (uint256)"
												}
											},
											"id": 1953,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "420:23:19",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1954,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "446:1:19",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "420:27:19",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1942,
									"id": 1956,
									"nodeType": "Return",
									"src": "413:34:19"
								}
							]
						},
						"documentation": null,
						"id": 1958,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1939,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1936,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 1958,
									"src": "275:17:19",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1935,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "275:7:19",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1938,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1958,
									"src": "294:15:19",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1937,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "294:7:19",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "274:36:19"
						},
						"payable": false,
						"returnParameters": {
							"id": 1942,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1941,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1958,
									"src": "335:4:19",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1940,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "335:4:19",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "334:6:19"
						},
						"scope": 1959,
						"src": "249:203:19",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 1960,
				"src": "82:372:19"
			}
		],
		"src": "0:455:19"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.806Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/MorganStarkFactory.json
// module id = 1047
// module chunks = 0